const SKELETON_ROW_KEYS = ["row-1", "row-2", "row-3"] as const;

export const Skeleton = () => {
  return (
    <div className="tw-absolute tw-top-0 tw-size-full tw-gap-8 tw-flex tw-items-center tw-z-1 tw-animate-skeleton-loading">
      <div className="tw-pl-[7px]">
        <div className="tw-size-[126px] tw-rounded-full tw-bg-blue-100/50 tw-flex tw-items-center tw-justify-center">
          <span className="tw-size-2/3 tw-rounded-full tw-bg-white tw-block"></span>
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-pl-2 tw-flex-1">
        {SKELETON_ROW_KEYS.map((key) => (
          <div key={key} className="tw-flex tw-items-center tw-gap-2 tw-h-4">
            <span className="tw-rounded-sm tw-block tw-size-3 tw-bg-blue-100/50"></span>
            <span className="tw-block tw-h-1.5 tw-w-12 tw-rounded-lg tw-bg-blue-100/50"></span>
            <span className="tw-block tw-h-1.5 tw-w-8 tw-rounded-lg tw-bg-blue-100/50 tw-ml-auto"></span>
          </div>
        ))}
      </div>
    </div>
  );
};
